export default __webpack_public_path__ + "static/media/blob2.f4ec67e5.svg";